// 特性开关：本次只上「弹窗 + 提现提示 + 分享提示」，以下三块先还原成旧版，
// 以后要重新启用时把对应 flag 改成 true 再打包即可（新旧代码都保留在仓库里）。
export default {
  // 提现：false = 旧静态 html 提现页(withdraw-us.html)；true = 新 Vue 提现页(/withdraw-us)
  vueWithdraw: true,

  // 登录：false = 只手机号登录；true = 手机 / 邮箱两种(显示 Phone/Email 切换 tab)
  emailLogin: true,

  // 首页分享：false = 旧分享行(WhatsApp/Facebook/Instagram/Telegram/More)；
  //           true = 新版 6 图标行(SMS/Facebook/WhatsApp/Instagram/X/More)
  newShare: true
}
